import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { MatIconModule } from '@angular/material/icon'
import { RouterModule } from '@angular/router'
import { LoadingModule } from '@loading-lib/loading.module'
import { QuickFilterModule } from '@shared-ui-lib/quick-filter/quick-filter.module'
import { ReloadButtonModule } from '@shared-ui-lib/reload-button/reload-button.module'
import { RibbonModule } from '@shared-ui-lib/ribbon/ribbon.module'
import { HoverModule } from '@shared-util-lib/directives/hover/hover.module'
import { WidgetSkeletonComponent } from '../../shared/widget-skeleton/widget-skeleton.component'

@NgModule({
    declarations: [WidgetSkeletonComponent],
    exports: [WidgetSkeletonComponent],
    imports: [
        CommonModule,
        HoverModule,
        LoadingModule,
        MatIconModule,
        QuickFilterModule,
        ReloadButtonModule,
        RibbonModule,
        RouterModule,
    ],
})
export class WidgetSkeletonModule {}
